export default __webpack_public_path__ + "static/media/bazarvakil.2630e4ed.jpg";